import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

const IncludedSectionSkeleton = (props) => {
  const { itemsLength = 2 } = props;

  return (
    <Box my={3}>
      <Grid container spacing={2} mb={3}>
        <Grid item lg={2} md={2} sm={3}>
          <Skeleton variant="rounded" width="100%" height={60} />
        </Grid>
      </Grid>
      {[...Array(itemsLength).keys()].map((item) => (
        <Grid container spacing={3} rowSpacing={1} key={item}>
          <Grid item lg={2} md={2} sm={3}>
            <Box
              key={item}
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100%">
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          </Grid>
          <Grid item lg={10} md={10} sm={9}>
            <Skeleton variant="text" width="90%" height={50} />
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export { IncludedSectionSkeleton };
